import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      redirect: "/index"
    },
    {
      path: "/",
      name: "layout",
      component: resolve => require(["@/view/layout/index"], resolve),
      children: [
        {
          path: "/index",
          name: "home",
          component: () => import("@/view/home/home"),
          meta: { name: "首页", isFooter: true }
        },
        {
          path: "/organization",
          component: () => import("@/view/organization/index"),
          meta: { name: "服务机构", isFooter: true }
        },
        {
          path: "/org-details",
          component: () => import("@/view/organization/org-details"),
          meta: { name: "机构详情", isFooter: true }
        },
        {
          path: "/eva-details",
          component: () => import("@/view/organization/eva-details"),
          meta: { name: "服务评价", isFooter: true }
        },
        // {
        //     path: '/publicity',
        //     component: () =>
        //         import ('@/view/publicity/index'),
        //     meta: { name: "公示公告", isFooter: true }
        // },
        // {
        //     path: '/publicity-details',
        //     component: () =>
        //         import ('@/view/publicity/details'),
        //     meta: { name: "详情", isFooter: true }
        // },

        {
          path: "/policy",
          component: () => import("@/view/policy/index"),
          meta: { name: "政策解读", isFooter: true }
        },
        {
          path: "/policy-details",
          component: () => import("@/view/policy/details"),
          meta: { name: "详情", isFooter: true }
        },

        {
          path: "/publicity",
          component: () => import("@/view/publicity/index"),
          meta: { name: "公示公告", isFooter: true }
        },
        {
          path: "/publicity-details",
          component: () => import("@/view/publicity/details"),
          meta: { name: "公示公告详情", isFooter: true }
        },
        {
          path: "/problem",
          component: () => import("@/view/problem/index"),
          meta: { name: "常见问题", isFooter: true }
        },
        {
          path: "/problem-detail",
          component: () => import("@/view/problem/details"),
          meta: { name: "常见问题详情", isFooter: true }
        },
        {
          path: "/dataCenter",
          component: () => import("@/view/dataCenter/index"),
          meta: { name: "资料中心", isFooter: true }
        },
        {
          path: "/dataCenter-detail",
          component: () => import("@/view/dataCenter/details"),
          meta: { name: "资料中心详情", isFooter: true }
        },
        {
          path: "/user",
          meta: { name: "我的企业", isFooter: false },
          component: resolve => require(["@/view/user/index"], resolve),
          redirect: "/com/comInfo",
          children: [
            {
              path: "/com/comInfo",
              name: "企业信息",
              component: () => import("@/view/user/com/comInfo/index"),
              meta: {
                navlist: [
                  { name: "我的企业", path: "/user" },
                  { name: "企业信息", path: "/com/comInfo" }
                ]
              }
            },
            {
              path: "/com/comCollect",
              name: "机构收藏",
              component: () => import("@/view/user/com/comCollect/index"),
              meta: {
                navlist: [
                  { name: "我的企业", path: "/user" },
                  { name: "机构收藏", path: "/com/comCollect" }
                ]
              }
            },
            {
              path: "/com/cxq",
              name: "创新券",
              component: () => import("@/view/user/com/cxq/index"),
              meta: {
                navlist: [
                  { name: "我的企业", path: "/user" },
                  { name: "创新券", path: "/com/cxq" }
                ]
              }
            },
            {
              path: "/com/apply",
              name: "创新券申请",
              component: () => import("@/view/user/com/cxq/innovate-child/apply"),
              meta: {
                navlist: [
                  { name: "我的企业", path: "/user" },
                  { name: "创新券", path: "/com/cxq" }
                ]
              }
            },
            {
              path: "/com/myApply",
              name: "我的申报",
              component: () => import("@/view/user/com/myApply/index"),
              meta: {
                navlist: [
                  { name: "我的企业", path: "/user" },
                  { name: "我的申报", path: "/com/myApply" }
                ]
              }
            },
            // {
            //   path: "/serviceOrg/applySettled",
            //   name: "申请入驻",
            //   component: () =>
            //     import("@/view/user/serviceOrg/applySettled/index"),
            //   meta: {
            //     navlist: [
            //       { name: "我的企业", path: "/user" },
            //       { name: "申请入驻", path: "/serviceOrg/applySettled" }
            //     ]
            //   }
            // },
            {
              path: "/com/draft",
              name: "草稿箱",
              component: () => import("@/view/user/com/draft/index"),
              meta: {
                navlist: [
                  { name: "草稿箱", path: "/com/draft" }
                ]
              }
            },
            {
              path: "/serviceOrg/draft",
              name: "草稿箱",
              component: () => import("@/view/user/serviceOrg/draft/index"),
              meta: {
                navlist: [
                  { name: "草稿箱", path: "/serviceOrg/draft" }
                ]
              }
            },

            {
              path: "/serviceOrg/serviceOrgInfo",
              name: "机构信息",
              component: () =>
                import("@/view/user/serviceOrg/serviceOrgInfo/index"),
              meta: {
                navlist: [
                  { name: "服务机构", path: "/serviceOrg/serviceOrgInfo" },
                  { name: "机构信息", path: "/serviceOrg/serviceOrgInfo" }
                ]
              }
            },
            {
              path: "/serviceOrg/cxqCash",
              name: "创新兑付",
              component: () => import("@/view/user/serviceOrg/cxqCash/index"),
              meta: {
                navlist: [
                  { name: "服务机构", path: "/serviceOrg/serviceOrgInfo" },
                  { name: "创新兑付", path: "/serviceOrg/cxqCash" }
                ]
              }
            },
            {
              path: "/serviceOrg/applySettled/apply",
              name: "泉州市科技创新券服务机构入库申请表",
              component: () => import("@/view/user/serviceOrg/applySettled/flow/apply"),
              meta: {
                navlist: [
                  { name: "服务机构", path: "/serviceOrg/serviceOrgInfo" },
                  { name: "创新兑付", path: "/serviceOrg/cxqCash" }
                ]
              }
            },
            {
              path: "/serviceOrg/cxqCash/apply",
              name: "泉州市科技创新券兑现项目申请表",
              component: () => import("@/view/user/serviceOrg/cxqCash/child/apply"),
              meta: {
                navlist: [
                  { name: "服务机构", path: "/serviceOrg/serviceOrgInfo" },
                  { name: "创新兑付", path: "/serviceOrg/cxqCash" }
                ]
              }
            },
            {
              path: "/serviceOrg/serviceOrgModify",
              name: "信息修改申请",
              component: () =>
                import("@/view/user/serviceOrg/serviceOrgModify/index"),
              meta: {
                navlist: [
                  { name: "服务机构", path: "/serviceOrg/serviceOrgInfo" },
                  { name: "信息修改申请", path: "/serviceOrg/serviceOrgModify" }
                ]
              }
            },
            {
              path: "/com/comModify",
              name: "信息修改申请",
              component: () =>
                import("@/view/user/com/comModify/index"),
              meta: {
                navlist: [
                  { name: "我的企业", path: "/user" },
                  { name: "信息修改申请", path: "/com/comModify" }
                ]
              }
            },
            
            {
              path: "/serviceOrg/annualInspect",
              name: "到期资格审查",
              component: () =>
                import("@/view/user/serviceOrg/annualInspect/index"),
              meta: {
                navlist: [
                  { name: "服务机构", path: "/serviceOrg/serviceOrgInfo" },
                  { name: "到期资格审查", path: "/serviceOrg/annualInspect" }
                ]
              }
            },
            {
              path: "/serviceOrg/myApply",
              name: "我的申报",
              component: () => import("@/view/user/serviceOrg/myApply/index")
            },
            {
              path: "/serviceOrg/applySettled",
              name: "服务机构入驻",
              component: () =>
                import("@/view/user/serviceOrg/applySettled/index"),
              meta: {
                navlist: [
                  { name: "我的企业", path: "/user" },
                  { name: "服务机构入驻", path: "/serviceOrg/applySettled" }
                ]
              }
            },
            {
              path: "/serviceOrg/apply",
              name: "服务机构入驻申请",
              component: () =>
                import("@/view/user/serviceOrg/applySettled/flow/apply"),
              meta: {
                navlist: [
                  { name: "我的企业", path: "/user" },
                  { name: "服务机构入驻", path: "/serviceOrg/applySettled" }
                ]
              }
            }
          ]
        },

        {
          path: "/register",
          component: () => import("@/view/login/register"),
          meta: { name: "注册", isFooter: false }
        },
        {
          path: "/login",
          component: () => import("@/view/login/login"),
          meta: { name: "登录", isFooter: false }
        }
      ]
    }
  ]
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js